import { DefaultTheme } from 'styled-components';
import { isAtMostMobile } from '@optimus-web/breakpoints';
import { getSpacingToken } from '@optimus-web/common';
import { BreakpointRangeWithFallback } from '../../types';
import { getBreakpointRangeValueFallback } from '../../utils/breakpointsFallback';
import { MONTH_WIDTH } from '../style';

export const updateContainerWidth = (
    monthGridContainerElement: HTMLElement | null = null,
    numberOfMonths: number,
    breakpointRange: BreakpointRangeWithFallback,
    theme: DefaultTheme
) => {
    if (monthGridContainerElement) {
        monthGridContainerElement.style.width = isAtMostMobile(getBreakpointRangeValueFallback(breakpointRange))
            ? `${(window.innerWidth - getSpacingToken('400')({ theme })) * numberOfMonths}px`
            : `${MONTH_WIDTH * numberOfMonths}px`;
    }
};
